import { createFileRoute } from "@tanstack/react-router";
import { useAppTranslation } from "@/hooks/use-app-translation";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/home",
)({
	component: AdminDashboard,
});

function AdminDashboard() {
	const { t } = useAppTranslation();

	return (
		<div className="p-8 space-y-8">
			{/* Page Header */}
			<div>
				<h1 className="text-3xl font-bold text-gray-900">
					{t("admin./.title")}
				</h1>
				<p className="mt-2 text-gray-600">{t("admin./.description")}</p>
			</div>
		</div>
	);
}
